import React, { useContext, useEffect, useState } from "react";
import bagImage from "../../../assets/bag-solid.png";
import cashMultiple from "../../../assets/cash-multiple.png";
import { FaAngleLeft, FaAngleRight, FaLocationDot } from "react-icons/fa6";
import {
  EventButton,
  PaginationBtn,
  StepperBackButton,
} from "../../../User/component/ReUseComps/Button";
import { useNavigate, useParams } from "react-router-dom";
import CompanyContext from "../../Component/ContextAPI/CompanyContext";
import CandaidateProfileView from "../../Component/PopupModal/AppliedCandidateProfile/CandaidateProfileView";
import NoCandidateApplied from "./NoCandidateApplied";
import suitcase from "../../../assets/solar_suitcase-outline.png";
import educationIcon from "../../../assets/fluent-mdl2_education.png";
import mage_email from "../../../assets/mage_email.png";
import weui_location from "../../../assets/weui_location-outlined.png";
import { COMPANY_URLS } from "../../../Utils/Company_App_Urls";
import dummyIcon from "../../../assets/dummy-image.jpg";
import JobAppliedCandidate from "../Candidates/JobAppliedCandidate";
import axios from "axios";
import "./PostedJobDetails.css";

export const doenloadResume = (url, name) => {
  const encodedUrl = encodeURIComponent(url);
  axios
    .get(
      `https://backend-user.kaamvala.com/user-service/v1/user/download-resume/${encodedUrl}`,
      {
        headers: {
          Accept: "application/octet-stream",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
        responseType: "blob",
      }
    )
    .then((res) => {
      console.log(res);
      const blob = new Blob([res.data], { type: res.headers["content-type"] });
      const link = document.createElement("a");
      link.href = URL.createObjectURL(blob);
      link.setAttribute("download", name);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    })
    .catch((err) => {
      console.log(err);
    });
};
export default function AppliedCandidatesList({
  getAllAppliedCandidates,
  singleJobDetails,
}) {
  const { setShowCandidateProfile, setAppliedCandidateDetails } =
    useContext(CompanyContext);

  const navigate = useNavigate();

  const handleToggleModalBox = (index) => {
    setShowCandidateProfile(true);
    setAppliedCandidateDetails({
      ...getAllAppliedCandidates[index],
      jobId: singleJobDetails?._id,
    });
  };

  return (
    <>
      <JobAppliedCandidate />
      <h1 className="appliedCandidatesListTitle pb-sm-1">
        <p className="mb-0 fs-5 fs-md-4">
          Applied Candidates{" "}
          <span>
            {getAllAppliedCandidates?.[0]?.name &&
              getAllAppliedCandidates?.length}{" "}
          </span>
        </p>
        <span onClick={() => navigate("/company/candidates")}>View All</span>
      </h1>
      {getAllAppliedCandidates?.[0]?.name ? (
        <div className="similar-job-main d-flex flex-column gap-2">
          {getAllAppliedCandidates?.map((job, index) => (
            <div
              key={index}
              className="similar-job-card d-flex flex-column gap-2"
            >
              <div className="similar-job-header d-flex align-items-start justify-content-between wrap">
                <div className="d-flex gap-1 align-items-center">
                  <div className="compy-logo-box">
                    <img src={job?.profile || dummyIcon} alt="Company Logo" />
                  </div>
                  <div className="compy-applied-title-descr">
                    <h1>{job?.name}</h1>
                    <p>{job?.JobTitle}</p>
                  </div>
                </div>
                {/* <p className='m-0'>{postedDate(job?.createdAt)}</p> */}
              </div>
              {/* <div className="candidateDetailsCard d-flex align-items-center gap-3">
                            {job.skills.map((skill, idx) => (
                                <div key={idx}>{skill}</div>
                            ))}
                        </div> */}
              {/* <div className="candidateDetailsCard d-flex align-items-center flex-wrap gap-3">
                            <div>{job?.experience}</div>
                            <div>{job?.education}</div>
                            {job?.languages?.map((lag, idx) => (
                                <div key={idx}>{lag?.languageFromMenu}</div>
                            ))}
                        </div> */}
              <div className="d-flex align-items-center justify-content-between gap-1 flex-wrap">
                <div className="d-flex align-items-center gap-1 candiApp-qulify text-capitalize">
                  <img src={suitcase} alt="suitcase" />
                  <span>{job?.experience}</span>
                </div>
                <div className="d-flex align-items-center gap-1 candiApp-qulify text-capitalize">
                  <img src={educationIcon} alt="suitcase" />
                  <span>{job?.education}</span>
                </div>
                <div className="d-flex align-items-center gap-1 candiApp-qulify">
                  <img src={mage_email} alt="suitcase" />
                  <span>{job?.email || "exapmple@yopmail.com"}</span>
                </div>
              </div>
              <div className="d-flex align-items-center justify-content-between text-capitalize">
                <div className="d-flex align-items-center gap-2 candiApp-qulify">
                  <img src={weui_location} alt="suitcase" />
                  <span>{job?.currentCity}</span>
                </div>
              </div>
              <div className="d-flex justify-content-between align-items-center flex-wrap gap-2">
                <button
                  className="out-line-button"
                  onClick={() =>
                    doenloadResume(job?.resume, `${job?.name}_resume`)
                  }
                  disabled={!job?.resume}
                >
                  {job?.resume ? "Download Resume" : "No Resume Found"}
                </button>
                <button
                  className="fill-bg-button"
                  onClick={() => handleToggleModalBox(index)}
                >
                  View Profile
                </button>
              </div>
            </div>
          ))}
        </div>
      ) : (
        <NoCandidateApplied />
      )}
      {/* {!getAllAppliedCandidates?.[0]?.name  && <NoCandidateApplied />} */}
    </>
  );
}
